import styled from 'styled-components';
import {iconColor} from '../../utils/styles';

const StyledIconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.size || 24}px;
  height: ${props => props.size || 24}px;
  transform: rotate(${props => props.rotate || 0}deg);

  svg {
    width: ${props => props.size || 24}px;
    height: ${props => props.size || 24}px;

    & > * {
      transition: fill 0.3s ease, stroke 0.3s ease;
    }

    ${props => props.ghost !== true && iconColor(props.color || props.theme.colors.neutral_6, true)}
  }
`;


export {
  StyledIconWrapper,
}
